<pas-button-round [color]="dark" (click)="onEditClick()" icon="{{ icon }}" size="small"></pas-button-round>
